const X_PROFILE_FIELDS =
    'username,name,bio,verified,url,statistics,entities,profile_image_url:avatar_url,profile_banner_url:banner_url';

/** Curator row with its profile fields read from the shared `x_profiles` table. */
export const CURATOR_SELECT = `id,user_id,visible,apps,created_at,updated_at,rest_id,x_profile_id,is_system,...x_profiles!x_profile_id(${X_PROFILE_FIELDS})`;

export const POST_SELECT = `*,curator:collectui_curators!curator_id(${CURATOR_SELECT})`;
